import React from 'react';
import { StepOne } from './Steps/StepOne';
import { StepTwo } from './Steps/StepTwo';
import { StepThree } from './Steps/StepThree';

export const LoggedSteps = ({ currentStep, ...stepProps }) => {
  const steps = [
    <StepOne 
      {...stepProps}
      isLogged={true}
    />,
    <StepTwo 
      {...stepProps}
      isLogged={true}
    />,
    <StepThree 
      {...stepProps}
      isLogged={true}
    />
  ];

  return steps[currentStep] || null;
};